export default "__VITE_ASSET__BWuQL8sB__"